import { render, staticRenderFns } from "./intelligentRecommendation.vue?vue&type=template&id=1ce543fe&scoped=true&"
import script from "./intelligentRecommendation.vue?vue&type=script&lang=js&"
export * from "./intelligentRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./intelligentRecommendation.vue?vue&type=style&index=0&id=1ce543fe&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce543fe",
  null
  
)

export default component.exports